/* eslint-disable prettier/prettier */
import React, { useEffect, useState } from 'react';
import {
  getKeyValueFromLocation,
  getVerifierState,
  removeCodeFromLocation,
  removeStateFromStorage
} from './authenticationHelper';
import authorize from './authorize';
import { fetchToken } from './fetchToken';

interface AuthenticationProviderTypes {
  children?: React.ReactNode;
  clientId?: string;
  provider?: string;
  authorizationEndpoint?: string;
  tokenEndpoint?: string;
  redirectUri?: string;
  clientSecret?: string;
}

const AuthenticationProvider = (props: AuthenticationProviderTypes): JSX.Element => {
  const { children, clientId, provider, authorizationEndpoint, tokenEndpoint, redirectUri, clientSecret } = props;
  const [token, setToken] = useState<string>();
  const [description, setDescription] = useState<string>('');
  const storage = sessionStorage;
  const scopes: string[] = ['openid', 'groups', 'profile'];
  const tokenInStorage = storage.getItem('API_TOKEN');
  useEffect(() => {
    const authChecker = async () => {
      if (!tokenInStorage) {
        const code = getKeyValueFromLocation({ location: window.location, keyName: 'code' });
        const state = getVerifierState({ clientId, storage });
        if (code && state) {
          try {
            setDescription('');
            const apiTokenFromSSO = await fetchToken({ clientId, tokenEndpoint, code, state, fetch, clientSecret });
            storage.setItem('API_TOKEN', apiTokenFromSSO['access_token']);
            storage.setItem('ID_TOKEN', apiTokenFromSSO['id_token']);
            storage.setItem('REFRESH_TOKEN' , apiTokenFromSSO['refresh_token']);
            setToken(apiTokenFromSSO);
            removeCodeFromLocation();
            removeStateFromStorage({ clientId, storage });
          } catch (e) {
            setDescription(e.message);
          }
        } else {
          //Redirect to SSO provider page
          const error_description = getKeyValueFromLocation({
            location: window.location,
            keyName: 'error_description',
          });
          if (!error_description) {
            await authorize({ redirectUri, provider, authorizationEndpoint, clientId, scopes,clientSecret });
          } else {
            setDescription(error_description.replace(/\+/g, ' '));
          }
        }
      } else {
        const lastVisitedPage = sessionStorage.getItem('LAST_VISITED_PAGE');
        if( lastVisitedPage) {
          sessionStorage.removeItem('LAST_VISITED_PAGE');
          window.location.href = lastVisitedPage;
        }
      }
    };
    authChecker();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [token, clientId, storage, tokenEndpoint, redirectUri, provider, authorizationEndpoint]);
  return (
    <>
      {tokenInStorage ? (
        children
      ) : (
        <div className="authenticationMessage">
          <h6>{description}</h6>
        </div>
      )}
    </>
  );
};
export default AuthenticationProvider;
